import { render, staticRenderFns } from "./FBComments.vue?vue&type=template&id=61e34634&"
import script from "./FBComments.vue?vue&type=script&lang=js&"
export * from "./FBComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports